import styled, { css } from 'styled-components';

interface IContainerProps {
  isErrored: boolean;
  isFocused: boolean;
  isField: boolean;
}

export const Container = styled.div<IContainerProps>`
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;

  input {
    ${props =>
      props.isErrored &&
      css`
        border-color: var(--red);
      `}
  }
`;
